import { paramCase, capitalCase } from 'change-case';
import { useParams, useLocation } from 'react-router-dom';
// @mui
import { Container } from '@mui/material';
// routes

// sections

import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
import useLocales from 'src/hooks/useLocales';
import useSettings from 'src/hooks/useSettings';
import { PATH_DASHBOARD } from 'src/routes/paths';
import Page from 'src/components/Page';
import RentPaymentNewEditForm from './RentPaymentNewEditForm';
// ----------------------------------------------------------------------

export default function RentPaymentCreate() {
  const { themeStretch } = useSettings();

  const { pathname } = useLocation();
  const { translate } = useLocales();
  const { name = '' } = useParams();

  const isEdit = pathname.includes('edit');

  return (
    <Page
      title={
        !isEdit
          ? `${translate('RentPayment.AddTitle')}`
          : `${translate('RentPayment.UpdateTitle')}`
      }
    >
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading={
            !isEdit
              ? `${translate('RentPayment.CreateRentPayment')}`
              : `${translate('RentPayment.EditRentPayment')}`
          }
          links={[
            { name: `${translate('Department.Dashboard')}`, href: PATH_DASHBOARD.root },
            {
              name: `${translate('RentPayment.RentPaymentList')}`,
              href: PATH_DASHBOARD.RentPayment.list,
            },
            {
              name: !isEdit
                ? `${translate('RentPayment.New')}`
                : `${translate('RentPayment.Update')}`,
            },
          ]}
        />
        {/* <RentPaymentNewEditForm /> */}
      </Container>
    </Page>
  );
}
